import type { RulesRepository } from '@/rule/domain/RulesRepository.ts';
import type { Rule } from '@/rule/domain/Rule.ts';
import type { RuleId } from '@/rule/domain/RuleId.ts';
import type { RuleStatus } from '@/rule/domain/RuleStatus.ts';
import { RulesFilter } from '@/rule/domain/RulesFilter.ts';
import type { AuthenticatedFetcher } from '@/generic/authentication';
import {
  parseJsonToRule,
  parseJsonToRulesPage,
  statusToJson,
} from '@/rule/secondary/CleanApiRulesJson.ts';
import { rulesListQueryOf } from '@/rule/secondary/RulesListQuery.ts';
import type { Page, Pagination } from '@/generic/pagination';

export class RulesCleanAPIHttp implements RulesRepository {
  readonly #fetcher: AuthenticatedFetcher;

  constructor(fetcher: AuthenticatedFetcher) {
    this.#fetcher = fetcher;
  }

  async list(pagination: Pagination, filter: RulesFilter): Promise<Page<Rule>> {
    return await this.#fetcher
      .fetch('/api/rules', {
        method: 'GET',
        query: rulesListQueryOf(pagination, filter),
      })
      .then(parseJsonToRulesPage);
  }

  async listActive(pagination: Pagination): Promise<Page<Rule>> {
    return await this.#fetcher
      .fetch('/api/rules', {
        method: 'GET',
        query: rulesListQueryOf(pagination, RulesFilter.none(), true),
      })
      .then(parseJsonToRulesPage);
  }

  async updateStatus(id: RuleId, status: RuleStatus): Promise<Rule> {
    return await this.#fetcher
      .fetch(`/api/rules/${id.value}`, {
        method: 'PATCH',
        body: { status: statusToJson(status) },
      })
      .then(parseJsonToRule);
  }
}
